import React from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon, PhoneFieldIcon } from '../../../_components'


export default function Bio( { values, handleChange, handleBlur, data, 
    setPrimaryContact, setSecondaryContact, setCOPhone, tag, details } ) {
  return (
    <Panel label="Farmer Biodata">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-3">
            <TextFieldIcon 
                name="registration_no"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.registration_no}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : true}
                question="Farmer Registration Number"
            />

            <TextFieldIcon 
                name="nin"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.nin}
                label="National ID Number"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Farmer's NIN"
            />

            <div className="hidden md:block lg:block"/>

            <TextFieldIcon 
                name="first_name"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.first_name}
                label="First Name"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Farmer First Name"
            />

            <TextFieldIcon 
                name="last_name"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.last_name}
                label="Last Name"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Farmer Last Name"
            />

            <TextFieldIcon 
                name="other_name"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.other_name}
                label="Other Name"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Farmer Other Name"
            />

            <TextFieldIcon 
                name="email"
                type="email"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.email}
                label="Email Address"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Farmer Email Address"
            />

            <PhoneFieldIcon 
                tag={tag}
                editValue={details?.primary_contact}
                name="primary_contact"
                handleChange={handleChange}
                handleBlur={handleBlur}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                callback={ ( phone ) => {
                    setPrimaryContact( phone )
                } }
                question="Primary Contact( Farmer )"
            />
            <PhoneFieldIcon 
                tag={tag}
                editValue={details?.secondary_contact}
                name="secondary_contact"
                handleChange={handleChange}
                handleBlur={handleBlur}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                callback={ ( phone ) => {
                    setSecondaryContact( phone )
                } }
                question="Secondary Contact( Farmer )"
            />
        </div>
        <div className="grid lg:grid-cols-3 lg:gap-3 md:grid-cols-2 md:gap-2">
            <SelectFieldIcon 
                name="birthyear"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.birthyear}
                label="Birth Year"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Year of Birth?"
                options={data.years.map( year => {
                    return { id: year, label: year, value: year }
                } )}
            />

            <SelectFieldIcon 
                name="sex"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.sex}
                label="Sex"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={true}
                question="Sex"
                options={data.sex.map( sex => ( { id: sex.id, label: sex.label, value: sex.value } ) )}
            />

            <SelectFieldIcon 
                name="gender"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.gender}
                label="Gender"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Gender"
                options={data.gender.map( gender => ( { id: gender.id, label: gender.label, value: gender.value } ) )}
            />
            <SelectFieldIcon 
                name="youth"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.youth}
                label="Youth"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Are you a youth?(18-35)"
                options={data.yesno.map( item => ( { id: item.id, label: item.label, value: item.value } ) )}
            />

            <SelectFieldIcon 
                name="pwd"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.pwd}
                label="PWD"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Are you a PWD?"
                options={data.yesno.map( item => ( { id: item.id, label: item.label, value: item.value } ) )}
            />
            <div />

            <PhoneFieldIcon 
                tag={tag}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                editValue={details?.co_phone}
                name="co_phone"
                handleChange={handleChange}
                handleBlur={handleBlur}
                callback={ ( phone ) => {
                    setCOPhone( phone )
                } }
                question="Farmer C/O Phone Number"
            />
        </div>
    </Panel>
  )
}
